import { render, staticRenderFns } from "./HousingApprentice.vue?vue&type=template&id=77dfccb6&scoped=true"
import script from "./HousingApprentice.vue?vue&type=script&lang=js"
export * from "./HousingApprentice.vue?vue&type=script&lang=js"
import style0 from "./HousingApprentice.vue?vue&type=style&index=0&id=77dfccb6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77dfccb6",
  null
  
)

export default component.exports